import { getCurrentUserInfo } from '@/api/exposure'

export default {
	namespaced: true,
	state: {
		userInfo: {}
	},
	getters: {
		userInfo: (state) => state.userInfo 
	},
	mutations: {
		SET_USERINFO (state, data) {
			state.userInfo = data.data
		}
	},
	actions: {
		async getCurrentUserInfo ({commit}) {
			commit('SET_USERINFO', await getCurrentUserInfo())
		}
	}
}


// WEBPACK FOOTER //
// ./src/store/modules/userInfo.js